import { h } from 'vue'
import OrganismContentCard from '~/components/organisms/content-card/content-card.vue'
import UiComponentContainer from '~ui/components/container/container.vue'

const Functional = (props) => {
  return h(
    UiComponentContainer,
    { class: 'resources' },
    () => [
      ...props.record.resources
        .map((resource) => {
          if (resource.__typename === 'QuizRecord') {
            const type = props.allResourceTypes.find(
              type => type.name === 'Quiz',
            )

            return {
              id: resource.id,
              backgroundImage: resource.backgroundImage,
              callToAction: type.cta,
              description: resource.shortDescription,
              image: resource.image,
              tagColor: type.color,
              tagIcon: type.icon,
              title: resource.shortTitle,
              to: props.localePath({
                name: 'resources-quiz-slug',
                params: {
                  slug: resource.slug,
                },
              }),
              topic: resource.resourceTopic.name,
              type: type.name,
            }
          }
          else if (resource.__typename === 'PillarPageRecord') {
            const type = props.allResourceTypes.find(
              type => type.name === 'Guides' || type.name === 'Guías',
            )

            return {
              id: resource.id,
              backgroundImage: resource.backgroundImage,
              callToAction: type.cta,
              description: resource.shortDescription,
              image: resource.image,
              tagColor: type.color,
              tagIcon: type.icon,
              title: resource.shortTitle,
              to: props.localePath({
                name: 'resources-guides-slug',
                params: {
                  slug: resource.slug,
                },
              }),
              topic: resource.resourceTopic.name,
              type: type.name,
            }
          }
          else {
            return {
              id: resource.id,
              backgroundImage: resource.backgroundImage,
              callToAction: resource.resourceType.cta,
              description: resource.shortDescription,
              image: resource.image,
              tagColor: resource.resourceType.color,
              tagIcon: resource.resourceType.icon,
              title: resource.shortTitle,
              to: resource.slug.includes('http')
                ? resource.slug
                : props.localePath({
                  name: 'resources-type-slug',
                  params: {
                    slug: resource.slug,
                    type: props.slugify(resource.resourceType.name),
                  },
                }),
              topic: resource.resourceTopic.name,
              type: resource.resourceType.name,
            }
          }
        })
        .map((content) => {
          return h(OrganismContentCard, {
            content,
          })
        }),
    ],
  )
}

Functional.props = {
  allResourceTypes: {
    required: true,
    type: Object,
  },
  localePath: {
    required: true,
    type: Function,
  },
  record: {
    required: true,
    type: Object,
  },
  slugify: {
    required: true,
    type: Function,
  },
}

export default Functional
